import {
  LayoutDashboard, Users, Phone, Target, Settings, DollarSign, CalendarDays,
  Factory, FileCheck, RotateCcw, Megaphone, ShieldAlert, Banknote, Contact, Headset,
  UserPlus, TrendingUp, ListTodo,
} from 'lucide-react';

// Navigation unique, partagée par la barre latérale (bureau), la barre
// d'onglets et la feuille « Plus » (mobile). L'ordre du tableau est l'ordre
// d'affichage ; `tone` teinte l'icône de la page.
export const NAV_SECTIONS = ['Pilotage', 'Recrutement', 'LeadGen', 'Acquisition client', 'Parc Client', 'Installation / Production', 'Admin'];

export const NAV_ITEMS = [
  { label: 'Mes tâches',                         path: '/taches',          icon: ListTodo,        adminOnly: true,  section: 'Pilotage',                  tone: '#2F5BFF' },
  { label: 'Recrutement',                        path: '/recrutement',     icon: UserPlus,        adminOnly: true,  section: 'Recrutement',               tone: '#DB2777' },
  { label: 'Vue Exécutive',   short: 'Vue',      path: '/',                icon: LayoutDashboard, adminOnly: false, section: 'LeadGen',                   tone: '#2F5BFF' },
  { label: 'Par Commercial',  short: 'Sales',    path: '/salesperson',     icon: Users,           adminOnly: false, section: 'LeadGen',                   tone: '#0EA5E9' },
  { label: 'ROI & Coûts',     short: 'ROI',      path: '/roi',             icon: DollarSign,      adminOnly: false, section: 'LeadGen',                   tone: '#10B981' },
  { label: 'Leads Dormants',                     path: '/callcenter',      icon: Phone,           adminOnly: false, section: 'LeadGen',                   tone: '#C4183C' },
  { label: 'Cold Call',                          path: '/coldcall',        icon: Target,          adminOnly: true,  section: 'LeadGen',                   tone: '#0B6E99' },
  { label: 'Qualité Leads',                      path: '/lead-quality',    icon: ShieldAlert,     adminOnly: false, section: 'LeadGen',                   tone: '#B4590A' },
  { label: 'Méta Ads',                           path: '/meta',            icon: Megaphone,       adminOnly: true,  section: 'LeadGen',                   tone: '#2F5BFF' },
  { label: 'Sales Planning',  short: 'Planning', path: '/planning',        icon: CalendarDays,    adminOnly: false, section: 'Acquisition client',        tone: '#F59E0B' },
  { label: 'GRC / Contrats',                     path: '/grc',             icon: FileCheck,       adminOnly: true,  section: 'Acquisition client',        tone: '#047857' },
  { label: 'Upsell',                             path: '/upsell',          icon: TrendingUp,      adminOnly: true,  section: 'Parc Client',               tone: '#10B981' },
  { label: 'Renouvellements',                    path: '/renouvellements', icon: RotateCcw,       adminOnly: false, section: 'Parc Client',               tone: '#6437D6' },
  { label: 'Installation / Production',          path: '/production',      icon: Factory,         adminOnly: true,  section: 'Installation / Production', tone: '#8B5CF6' },
  { label: 'Clients',                            path: '/clients',         icon: Contact,         adminOnly: true,  section: 'Installation / Production', tone: '#0E7490' },
  { label: 'Service client',                     path: '/service-client',  icon: Headset,         adminOnly: true,  section: 'Installation / Production', tone: '#0E7490' },
  { label: 'Recouvrement',                       path: '/recouvrement',    icon: Banknote,        adminOnly: true,  section: 'Installation / Production', tone: '#B42318' },
  { label: 'Admin',                              path: '/admin',           icon: Settings,        adminOnly: true,  section: 'Admin',                  tone: '#8A93A3' },
];

/** L'entrée de navigation d'un chemin, sous-pages comprises (/clients/WEBFORCE_… → Clients). */
// Pages accessibles par lien mais absentes du menu : leur titre dans la barre du haut.
export const TITRES_HORS_MENU = { '/rh': 'Suivi RH', '/mon-compte': 'Mon compte' };

export function navItemDe(pathname) {
  return NAV_ITEMS.find((n) => n.path === pathname)
    || NAV_ITEMS.filter((n) => n.path !== '/' && pathname.startsWith(`${n.path}/`)).sort((a, b) => b.path.length - a.path.length)[0]
    || null;
}

/** Les 4 onglets permanents de la barre mobile (le 5e est « Plus »). */
export const MOBILE_TAB_PATHS = ['/', '/salesperson', '/planning', '/roi'];

/** Sections non vides, dans l'ordre, pour un prédicat d'accès donné. */
export function navSections(canSee) {
  return NAV_SECTIONS
    .map((title) => ({ title, items: NAV_ITEMS.filter((n) => n.section === title && canSee(n)) }))
    .filter((s) => s.items.length > 0);
}

/**
 * L'utilisateur voit-il cette page ? Même règle que la barre latérale
 * (AppLayout.canSeeNavItem) : admin tout ; liste permitted_pages ; sinon tout
 * ce qui n'est pas réservé à l'admin.
 */
export function aAcces(user, path) {
  if (user?.is_admin || user?.role === 'admin') return true;
  if (Array.isArray(user?.permitted_pages)) return user.permitted_pages.includes(path);
  return !NAV_ITEMS.find((n) => n.path === path)?.adminOnly;
}
